export const sanitizeString = (string) => {
    if((typeof string !== 'string'))
    {
        return ''
    }

    return string.trim()
}

export const isEmptyString = (string) => {
    return sanitizeString(string).length === 0
}

export const isEmpty = value => {
    return value === null || value === '' || value === 0
}
